import { Modal } from 'antd'
import PropTypes from 'prop-types'
import './ModalCommon.scss'

export const ModalCommon = ({
	title,
	visible,
	closable,
	okText,
	cancelText,
	handleOk,
	handleCancel,
	children,
	footer = null,
	width,
	className = '',
	centered,
}) => {
	return (
		<Modal
			centered={centered}
			className={className}
			title={title}
			visible={visible}
			onOk={handleOk}
			onCancel={handleCancel}
			footer={footer}
			okText={okText}
			cancelText={cancelText}
			width={width}
			closable={closable}
		>
			{children}
		</Modal>
	)
}

ModalCommon.propTypes = {
	title: PropTypes.string,
	visible: PropTypes.bool,
	children: PropTypes.node,
	handleOK: PropTypes.func,
	handleCancel: PropTypes.func,
	okText: PropTypes.string,
	cancelText: PropTypes.string,
	closable: PropTypes.any,
	handleOk: PropTypes.any,
	footer: PropTypes.any,
	width: PropTypes.any,
	className: PropTypes.string,
	centered: PropTypes.any,
}
